export const handleDownload = (path, index) => {
    const a = document.createElement('a');
    a.href = path;
    a.download = `Image-${index + 1}.jpeg`; // Assuming the images are in JPG format
    document.body.appendChild(a);
    a.style.display = 'none';
    a.click();
    document.body.removeChild(a);
  };
  